export function PolicySettingsSection({
  label,
  description,
  children,
}: {
  label: string;
  description: string;
  children: React.ReactNode;
}) {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-col gap-0.5">
        <span className="text-default-500 text-xs font-semibold">{label}</span>
        <span className="text-default-400 text-xs">{description}</span>
      </div>
      <div className="flex flex-col gap-3">{children}</div>
    </section>
  );
}
